import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCollide from './VueCollide'
import VueScrollTo from 'vue-scrollto'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

let fireConfig = {
	apiKey: 'AIzaSyD8dLj87pYQoAMGq4qGlFNiNgJMyLxA5s0',
	authDomain: 'borjomi-2eb09.firebaseapp.com',
	databaseURL: 'https://borjomi-2eb09.firebaseio.com',
	projectId: 'borjomi-2eb09',
	storageBucket: 'borjomi-2eb09.appspot.com',
	messagingSenderId: '1063152650766',
}
firebase.initializeApp(fireConfig)

Vue.config.productionTip = false
Vue.use(VueCollide)
Vue.use(VueScrollTo, {
	container: '#view',
	duration: 400,
	easing: 'ease',
	offset: 0,
	cancelable: false,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: false,
	y: true,
})

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
